import styles from "./historical.module.css";

import moment from "moment";
import { observer, inject } from "mobx-react";
import LastDaysPanel from "./last-days.panel";
import web from "../../web";
import { IClientStatus } from "../../store/types";
import { TabContainer } from "../../components/tabs/tab-container";
import { useEffect } from "react";
import { ClientStatusesConverter } from "../../store/convertor";
import { useTranslation } from "react-i18next";
import { ClientDashboardStore } from "../../store/store";

export interface IHistoricalViewProps {
    clientId: number;
    clientDashboardStore?: ClientDashboardStore;
}

function HistoricalViewComponent(props: IHistoricalViewProps) {
    const { t } = useTranslation("dashboard");
    const clientDashboardStore = props.clientDashboardStore!;
    const { clientStatuses } = clientDashboardStore;

    useEffect(() => {
        const clientDashboardStore = props.clientDashboardStore!;

        clientDashboardStore.setHistoricalTab(0);

        web.readStatusSummary(props.clientId)
            .then((result: any) => {
                const clientStatuses = result.data
                    .clientStatuses as IClientStatus[];

                const statusSummary24h = result.data.resident24HrsStatusSummary;

                const clientStatusesList = clientStatuses.map(
                    (clientStatus) => {
                        return ClientStatusesConverter.toStore(clientStatus);
                    }
                );

                clientDashboardStore.clientStatuses = [...clientStatusesList];

                const filteredList = clientStatusesList.slice(0, -1);

                clientDashboardStore!.periodStatistics.daily.hours.OutOfRoom +=
                    statusSummary24h.hoursOutOfRoom;
                clientDashboardStore!.periodStatistics.daily.hours.InBathroom +=
                    statusSummary24h.hoursInBathroom;
                clientDashboardStore!.periodStatistics.daily.hours.InRoom +=
                    statusSummary24h.hoursInRoom;
                clientDashboardStore!.periodStatistics.daily.hours.InBed +=
                    statusSummary24h.hoursInBed;
                clientDashboardStore!.periodStatistics.daily.hours.OutOfBed +=
                    statusSummary24h.hoursOutOfBed;

                clientDashboardStore!.periodStatistics.daily.count.OutOfRoom +=
                    statusSummary24h.timesOutOfRoom;
                clientDashboardStore!.periodStatistics.daily.count.InBathroom +=
                    statusSummary24h.timesInBathroom;
                clientDashboardStore!.periodStatistics.daily.count.InRoom +=
                    statusSummary24h.timesInRoom;
                clientDashboardStore!.periodStatistics.daily.count.InBed +=
                    statusSummary24h.timesInBed;
                clientDashboardStore!.periodStatistics.daily.count.OutOfBed +=
                    statusSummary24h.timesOutOfBed;

                statusSummary24h.residentExternalStatusSummaries.map(
                    (summary: any) => {
                        clientDashboardStore!.periodStatistics.daily.hours.Other +=
                            summary.hours;

                        clientDashboardStore!.periodStatistics.daily.count.Other +=
                            summary.times;
                    }
                );

                filteredList.map((statusDayData, index) => {
                    let otherTimes = 0;
                    let otherHours = 0;

                    statusDayData.residentExternalStatusSummaries.map(
                        (status) => {
                            otherTimes += status.times;
                            otherHours += status.hours;
                        }
                    );

                    if (index > filteredList.length - 1 - 7) {
                        clientDashboardStore!.periodStatistics.sevenDays.hours.OutOfRoom +=
                            statusDayData.hoursOutOfRoom;
                        clientDashboardStore!.periodStatistics.sevenDays.hours.InBathroom +=
                            statusDayData.hoursInBathroom;
                        clientDashboardStore!.periodStatistics.sevenDays.hours.InRoom +=
                            statusDayData.hoursInRoom;
                        clientDashboardStore!.periodStatistics.sevenDays.hours.InBed +=
                            statusDayData.hoursInBed;
                        clientDashboardStore!.periodStatistics.sevenDays.hours.OutOfBed +=
                            statusDayData.hoursOutOfBed;
                        clientDashboardStore!.periodStatistics.sevenDays.hours.Other +=
                            otherHours;

                        clientDashboardStore!.periodStatistics.sevenDays.count.OutOfRoom +=
                            statusDayData.timesOutOfRoom;
                        clientDashboardStore!.periodStatistics.sevenDays.count.InBathroom +=
                            statusDayData.timesInBathroom;
                        clientDashboardStore!.periodStatistics.sevenDays.count.InRoom +=
                            statusDayData.timesInRoom;
                        clientDashboardStore!.periodStatistics.sevenDays.count.InBed +=
                            statusDayData.timesInBed;
                        clientDashboardStore!.periodStatistics.sevenDays.count.OutOfBed +=
                            statusDayData.timesOutOfBed;
                        clientDashboardStore!.periodStatistics.sevenDays.count.Other +=
                            otherTimes;
                    }

                    clientDashboardStore!.periodStatistics.thirtyDays.hours.OutOfRoom +=
                        statusDayData.hoursOutOfRoom;
                    clientDashboardStore!.periodStatistics.thirtyDays.hours.InBathroom +=
                        statusDayData.hoursInBathroom;
                    clientDashboardStore!.periodStatistics.thirtyDays.hours.InRoom +=
                        statusDayData.hoursInRoom;
                    clientDashboardStore!.periodStatistics.thirtyDays.hours.InBed +=
                        statusDayData.hoursInBed;
                    clientDashboardStore!.periodStatistics.thirtyDays.hours.OutOfBed +=
                        statusDayData.hoursOutOfBed;
                    clientDashboardStore!.periodStatistics.thirtyDays.hours.Other +=
                        otherHours;

                    clientDashboardStore!.periodStatistics.thirtyDays.count.OutOfRoom +=
                        statusDayData.timesOutOfRoom;
                    clientDashboardStore!.periodStatistics.thirtyDays.count.InBathroom +=
                        statusDayData.timesInBathroom;
                    clientDashboardStore!.periodStatistics.thirtyDays.count.InRoom +=
                        statusDayData.timesInRoom;
                    clientDashboardStore!.periodStatistics.thirtyDays.count.InBed +=
                        statusDayData.timesInBed;
                    clientDashboardStore!.periodStatistics.thirtyDays.count.OutOfBed +=
                        statusDayData.timesOutOfBed;
                    clientDashboardStore!.periodStatistics.thirtyDays.count.Other +=
                        otherTimes;
                });
            })
            .catch(() => {});
    }, []);

    const render = () => {
        const offSetDays = 1;

        const thirtyDaysHoursData = clientStatuses
            .slice(0, clientStatuses.length - offSetDays)
            .map(mapHours);
        const thirtyDaysTimesData: any = clientStatuses
            .slice(0, clientStatuses.length - offSetDays)
            .map(mapTimes);

        const sevenDaysHoursData = clientStatuses
            .slice(-7 - offSetDays, clientStatuses.length - offSetDays)
            .map(mapHours);
        const sevenDaysTimesData: any = clientStatuses
            .slice(-7 - offSetDays, clientStatuses.length - offSetDays)
            .map(mapTimes);

        const lastStatus = clientDashboardStore.statusesAndAlerts.find(
            (el: any) => {
                return el.type === 1;
            }
        );

        if (lastStatus) {
            if (lastStatus.typeId === 2) {
                if (sevenDaysTimesData.length > 0) {
                    sevenDaysTimesData[
                        sevenDaysTimesData.length - 1
                    ].timesInBed -= 1;
                    thirtyDaysTimesData[
                        thirtyDaysTimesData.length - 1
                    ].timesInBed -= 1;
                }
            }
        }

        return (
            <div className={styles["historical-view"]}>
                <div className={styles["tab-container"]}>
                    <TabContainer
                        onTabChange={(index: number) => {
                            clientDashboardStore.setHistoricalTab(index);
                        }}
                        defaultTab={0}
                        tabList={[
                            {
                                component: (
                                    <LastDaysPanel
                                        isSevenDaysView
                                        hoursData={sevenDaysHoursData}
                                        timesData={sevenDaysTimesData}
                                    />
                                ),
                                title: t("Last 7 days"),
                            },
                            {
                                component: (
                                    <LastDaysPanel
                                        isSevenDaysView={false}
                                        hoursData={thirtyDaysHoursData}
                                        timesData={thirtyDaysTimesData}
                                    />
                                ),
                                title: t("Last 30 days"),
                            },
                        ]}
                    />
                </div>
            </div>
        );
    };

    const mapHours = (c: IClientStatus) => {
        let hoursOtherValue = 0;

        if (c.residentExternalStatusSummaries)
            c.residentExternalStatusSummaries.map((status) => {
                hoursOtherValue += status.hours;
            });

        return {
            day: moment(c.timeStamp).format("D"),
            hoursInBathroom: c.hoursInBathroom,
            hoursInBed: c.hoursInBed,
            hoursOutOfBed: c.hoursOutOfBed,
            hoursInRoom: c.hoursInRoom,
            hoursOutOfRoom: c.hoursOutOfRoom,
            hoursOther: hoursOtherValue,
        };
    };

    const mapTimes = (c: IClientStatus) => {
        let timesOtherValue = 0;

        if (c.residentExternalStatusSummaries)
            c.residentExternalStatusSummaries.map((status) => {
                timesOtherValue += status.times;
            });

        return {
            day: moment(c.timeStamp).format("D"),
            timesInBed: c.timesInBed,
            timesOutOfBed: c.timesOutOfBed,
            timesInBathroom: c.timesInBathroom,
            timesInRoom: c.timesInRoom,
            timesOutOfRoom: c.timesOutOfRoom,
            timesOther: timesOtherValue,
        };
    };

    return render();
}

export const HistoricalView = inject("clientDashboardStore")(
    observer(HistoricalViewComponent)
);
